import DataTable from "common/components/DataTable/DataTable";
import PaginationFooter from "common/components/PaginationFooter";

import type { Table as TableType } from "@tanstack/react-table";
import type { ComponentProps } from "react";

interface PaginatedDataTableProps<TData extends { id: string }>
  extends Pick<
    ComponentProps<typeof DataTable<TData>>,
    "onRowClick" | "isLoading" | "selectionActionsComponent"
  > {
  title: string;
  table: TableType<TData>;
}

export default function PaginatedDataTable<TData extends { id: string }>({
  title,
  table,
  onRowClick,
  isLoading,
  selectionActionsComponent,
}: PaginatedDataTableProps<TData>) {
  const { getState, setPageIndex, getCoreRowModel, setPageSize } = table;

  const { pageIndex, pageSize } = getState().pagination;

  const totalItemCount = getCoreRowModel().rows.length;

  return (
    <>
      <DataTable
        title={title}
        table={table}
        onRowClick={onRowClick}
        totalItemCount={totalItemCount}
        isLoading={isLoading}
        selectionActionsComponent={selectionActionsComponent}
      />

      <PaginationFooter
        selectedPage={pageIndex}
        setSelectedPage={(page) => setPageIndex(page)}
        pageSize={pageSize}
        setPageSize={(newPage) => setPageSize(newPage)}
        totalItemCount={totalItemCount}
        isLastPageHidden={false}
      />
    </>
  );
}
